// extracted by mini-css-extract-plugin
export default {"productDescription":"A--z","featuredDescription":"B--z","description":"C--z","more":"D--z","descriptionSku":"E--z"};